import type { CreatorApplication, CreatorApplicationStatus } from "@coinfallsmp/shared";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listApplications } from "../api.js";
import StatusBadge from "../components/StatusBadge.js";

const FILTERS: Array<CreatorApplicationStatus | "all"> = [
  "all",
  "pending",
  "needs_info",
  "approved",
  "rejected",
];

export default function Applications() {
  const [filter, setFilter] = useState<CreatorApplicationStatus | "all">("pending");
  const [items, setItems] = useState<CreatorApplication[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    listApplications(filter)
      .then((res) => setItems(res.items))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <section>
      <div className="page-header">
        <h1>Creator applications</h1>
      </div>

      <div className="filter-tabs">
        {FILTERS.map((f) => (
          <button
            key={f}
            className={f === filter ? "tab active" : "tab"}
            onClick={() => setFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="status-message">Loading…</p>
      ) : items.length === 0 ? (
        <p className="status-message">No applications here.</p>
      ) : (
        <table className="video-table">
          <thead>
            <tr>
              <th>Requested username</th>
              <th>Display name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Submitted</th>
            </tr>
          </thead>
          <tbody>
            {items.map((app) => (
              <tr key={app.id}>
                <td>
                  <Link to={`/applications/${app.id}`}>{app.requestedUsername}</Link>
                </td>
                <td>{app.displayName}</td>
                <td>{app.email}</td>
                <td>
                  <StatusBadge status={app.status} />
                </td>
                <td>{new Date(app.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
